import { Pipe, PipeTransform } from '@angular/core';

import { JupiterInspectionNote } from '../types/jupiter-inspection-note.type';

@Pipe({
  name: 'inspectionNoteText',
})
export class InspectionNoteTextPipe implements PipeTransform {
  transform(inspectionNote: JupiterInspectionNote): string {
    const noteKeys = inspectionNote.text.trim().split(' ');
    const notes = noteKeys.map((word) =>
      word
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace('Lv', 'Level ')
        .trim(),
    );

    return notes.join(', ');
  }
}
